module.exports = __webpack_public_path__ + "img/emoticon-csat-1-on.00814385.svg";